export default class Constants {
  static readonly DOUBLE_CLICK_DELAY_IN_MILLIS = 250;

  static readonly SHOW_TOOLTIP_DELAY_IN_MILLIS = 500;

  static readonly HIDE_TOOLTIP_DELAY_IN_MILLIS = 200;
}
